/**
 * Tooltip 모드 처리 관련 구현
 *   - Tooltip 모드 : 클릭시 / 마우스 오버시 / None
 */

import { ToastProgrammatic as Toast } from 'buefy'

import Plotly from 'plotly.js-dist'
import BriqueChart from './BriqueChart.vue'
import EventHandler from './EventHandler.js'

export default {
  /**
   * 툴팁 모드에 따른 동작 구현
   * @param {string} element 차트 Element
   */
  initTooltipMode (element) {
    // element.on('plotly_hover', function (eventdata) {
    //   // console.log(eventdata.points)
    //   // // let points = eventdata.points[0]
    //   // // let pointNum = points.pointNumber

    //   // Plotly.Fx.hover(`${elId}`, [
    //   //   // { curveNumber: 0, pointNumber: pointNum },
    //   //   // { curveNumber: 1, pointNumber: pointNum }
    //   //   // { curveNumber: 2, pointNumber: pointNum }
    //   // ])

    //   eventdata.event.stopPropagation()
    //   eventdata.event.preventDefault()
    //   console.log(arguments)

    //   return false
    // })

    // console.log(Plotly)
    // element._internalEv.removeListener('plotly_hover', function (eventdata) {
    //   console.log(Plotly)
    //   console.log(arguments)
    //   eventdata.event.stopPropagation()
    //   eventdata.event.preventDefault()
    //   eventdata.event.stopImmediatePropagation()
    //   return false
    // })

    element.on('plotly_beforehover', function (e) {
      // console.log('plotly_beforehover')

      let briqueChartOption = element.briqueChartOption

      if (briqueChartOption.tooltip.mode === 'click') {
        if (e.buttons === 1) { // left button click
          // 이벤트를 정상적으로 진행하여 마우스 클릭시 마우스 오버 이벤트도 발생하게 되어 툴팁이 표시된다.
        } else {
          return false // 이벤트 중단 - 이벤트를 중단하여 마우스 오버시 툴팁이 표시되는 것을 막는다.
        }
      } else if (briqueChartOption.tooltip.mode === 'none') {
        return false // 이벤트 중단 - 이벤트를 중단하여 마우스 오버시 툴팁이 표시되는 것을 막는다.
      }
    })

    // element.on('plotly_legendclick', function (data) {
    //   console.log('plotly_legendclick')
    //   // 마우스 클릭시 남아 있는 Tooltip을 제거한다.
    //   Plotly.Fx.unhover(element, [
    //     { curveNumber: 0, pointNumber: 0 },
    //     { curveNumber: 0, pointNumber: 0 }
    //   ])
    // })

    // element.on('plotly_click', function (eventData) {
    //   console.log('plotly_click')

    //   let briqueChartOption = element.briqueChartOption

    //   if (briqueChartOption.tooltip.mode === 'click') {
    //     let hoverPoints = []
    //     for (let point of eventData.points) {
    //       hoverPoints.push({
    //         curveNumber: point.curveNumber,
    //         pointNumber: point.pointNumber
    //       })
    //     }

    //     Plotly.Fx.hover(`${elId}`, hoverPoints)
    //   }
    // })

    EventHandler.removeAndAddEventListener(element, `click.${element.id}`, function (e) {
      // console.log('click')

      let inner = element.querySelector(`.nsewdrag`) // 차트 안쪽 부분
      if (_.isEmpty(inner)) return false
      let rect = inner.getBoundingClientRect()

      // 데이터 표시 영역이 아닌 부분
      if (rect.left > e.clientX || rect.right < e.clientX || rect.top > e.clientY || rect.bottom < e.clientY) {
        // 마우스 클릭시 남아 있는 Tooltip을 제거한다.
        Plotly.Fx.unhover(element, [
          { curveNumber: 0, pointNumber: 0 },
          { curveNumber: 0, pointNumber: 0 }
        ])
      }
    })

    EventHandler.removeAndAddEventListener(window, `resize.${element.id}`, _.debounce(function () {
      // 다른 화면으로 전환되었다면 이벤트 제거
      if (_.isEmpty(document.getElementById(element.id))) {
        EventHandler.removeAndAddEventListener(window, `resize.${element.id}`)
        return
      }

      // 마우스 클릭시 남아 있는 Tooltip을 제거한다.
      Plotly.Fx.unhover(element, [
        { curveNumber: 0, pointNumber: 0 },
        { curveNumber: 0, pointNumber: 0 }
      ])

      let briqueChartOption = element.briqueChartOption
      if (briqueChartOption.legend.position === 'bottom' || briqueChartOption.legend.position === 'left') {
        // Legend의 위치를 다시 계산한다
        BriqueChart.setLayoutFromLegendPosition(element, element.layout, briqueChartOption)
        BriqueChart.relayout(element, element.layout, true)
      }
    }, 500)) // _.debounce(function, 200) : 여러번 호출되는것 방지
  },

  /**
   * 툴팁 모드를 Chart에 적용한다.
   * @param {Object} element Chart Element
   */
  applyTooltipMode (element) {
    // let index = BRIQUECHART_TOOLTIP_MODES.indexOf(briqueChartOption.tooltip.mode)

    let briqueChartOption = element.briqueChartOption
    // briqueChartOption.tooltip.mode = BRIQUECHART_TOOLTIP_MODES[(index) % BRIQUECHART_TOOLTIP_MODES.length] // 3 toggle

    let tooltipModeOnHover = BriqueChart.getModeBarButton(element, 'tooltip.mode.hover')
    let tooltipModeOnClick = BriqueChart.getModeBarButton(element, 'tooltip.mode.click')
    let tooltipModeNone = BriqueChart.getModeBarButton(element, 'tooltip.mode.none')

    tooltipModeOnHover.visible = briqueChartOption.tooltip.mode === 'hover'
    tooltipModeOnClick.visible = briqueChartOption.tooltip.mode === 'click'
    tooltipModeNone.visible = briqueChartOption.tooltip.mode === 'none'

    BriqueChart.showHideModeBarButton(element, tooltipModeOnHover)
    BriqueChart.showHideModeBarButton(element, tooltipModeOnClick)
    BriqueChart.showHideModeBarButton(element, tooltipModeNone)

    if (tooltipModeOnHover.visible) {
      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_TOOLTIP_MOUSEOVER'),
        type: 'is-success',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    } else if (tooltipModeOnClick.visible) {
      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_TOOLTIP_CLICK'),
        type: 'is-success',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    } else if (tooltipModeNone.visible) {
      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_TOOLTIP_NONE'),
        type: 'is-success',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    }
  }
}
